import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { SketchPicker } from 'react-color'
import Popover from '../ui/Popover'

export default class ColorPicker extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string
  }

  handleFocus = e => {
    this.popover.setState({showing: true, target: e.target})
  }

  handleChange = (color) => {
    this.props.onChange(color.hex)
  }

  render () {
    const {value} = this.props

    return <div className='color-picker'>
      <div className='swatch' onClick={this.handleFocus}>
        <div className='color' style={{background: value}} />
      </div>
      <Popover ref={c => { this.popover = c }} placement='bottom center'>
        <SketchPicker color={value} onChange={this.handleChange} />
      </Popover>
    </div>
  }
}



// WEBPACK FOOTER //
// ./app/components/fields/ColorPicker.js